<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 mt-2">
                        <label class="vs-input--label">{{ $t('news.typePost') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="w-full" v-model="articleTypeModel" :clearable="false"
                            :options="articleTypeOptions" data-vv-validate-on="blur" v-validate="'required'"
                            name="articleType" disabled>
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('articleType') }}</span>
                    </div>
                    <div class="vx-col md:w-1/2 mt-2 ">
                        <label class="vs-input--label">{{ $t('news.roleView') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="w-full" v-model="authorizationTypeModel" :clearable="false"
                            :options="authorizationTypeOptions" data-vv-validate-on="blur" disabled
                            name="leaveStatus" v-validate="'required'">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('leaveStatusOptions') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 mt-2" v-if="!this.isUpdate">
                        <label class="vs-input--label">{{ $t('news.selectClass') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="w-full" v-model="classTypeModel" :clearable="false" :options="classOptions"
                            multiple data-vv-validate-on="blur" v-validate="'required'" name="selectClass"
                            @input="changeSelectClass(value)">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('selectClass') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 mt-2" v-if="this.isUpdate">
                        <label class="vs-input--label">{{ $t('news.selectClass') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="w-full" v-model="classTypeModelUpdate" :clearable="false"
                            :options="classOptions" data-vv-validate-on="blur" v-validate="'required'"
                            :disabled="isUpdate" name="selectClass">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('selectClass') }}</span>
                    </div>
                </div>


                <div class="row mt-4">
                    <div class="vx-col mt-2">
                        <label class="vs-input--label">{{ $t('news.titlePost') }}</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" :placeholder="$t('news.enterTitle')" v-model="newsInfo.title"
                            :disabled="isUpdate" v-validate="'required'" name="title" />
                        <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full mt-5 mb-4 quill-editor">
                        <label class="vs-input--label">{{ $t('news.contentPost') }}</label>
                        <quill-editor class="input-content" v-model="newsInfo.content"></quill-editor>
                    </div>

                </div>

                <br>
                <br>
                <br>
                <div  >
                    <div>
                        <label class="custom-file-input" for="Upload">
                        </label>
                        <input id="Upload" class="mb-4" type="file" :data="acceptData" @change="uploadFieldChange"
                            multiple style="visibility: hidden">
                        <vs-table stripe :data="filePostDTOS" noDataText="Không có dữ liệu" pagination max-items="5" v-if="!isUpdate && this.filePostDTOS.length > 0">
                            <template slot="thead">
                                <vs-th>Tệp đã chọn </vs-th>
                                <vs-th>Hành động</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(item, indextr) in data">
                                    <vs-td>
                                        <div>
                                            <a :href="item.url">{{ item.name }}</a>
                                        </div>
                                    </vs-td>
                                    <vs-td>
                                        <vx-tooltip class="position-icon mr-2" text="Xóa" position="top">
                                                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                                                    svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                                    @click="confirmDeleteFiles(item)" />
                                            </vx-tooltip>
                                    </vs-td>
                                </vs-tr>

                            </template>
                        </vs-table>
                    </div>
                </div>

                <div v-if="isUpdate && newsInfo.filePosts.length > 0">
                    <div>
                        <vs-table stripe :data="newsInfo.filePosts" noDataText="Không có dữ liệu" pagination
                            max-items="5">
                            <template slot="thead">
                                <vs-th>Tệp đã tải lên </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(item, indextr) in data">
                                    <vs-td> {{ item.name }}</vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>

                <!-- Save & Reset Button -->
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
                            <vs-button class="ml-auto mt-2" @click="saveChanges" v-if="!isUpdate">{{
                            $t('button.create')
                        }}
                            </vs-button>
                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="leaveList"> {{
                            $t('button.back') }}
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<script>

import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import utils from "../../../components/utils";
import moment from 'moment';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
import Multiselect from 'vue-multiselect';


export default {
    components: {
        vSelect,
        Datepicker,
        moment,
        utils,
        quillEditor,
        Multiselect

    },
    data() {
        return {
            content: '',
            nameImg: [],
            acceptData: '',
            dataFile: null,
            index: null,
            branchOptions: [],
            departmentOptions: [],
            classDeparments: [],
            classOptions: [
            ],
            classTypeModel: [],
            isShowOption: false,
            isShowSelected: false,
            optionChoose: null,
            isUpdate: false,
            articleTypeOptions: [
                { value: 4, label: this.$t('news.news') },
            ],
            authorizationTypeOptions: [
                { value: 1, label: this.$t('news.departmentLimit') },
            ],
            articleOptions: [],
            uploadPercent: 0,
            isShowPercent: false,
            newsInfo: {},
            filePostDTOS: [],
            file: [],
            isDragging: false,
            checkFile: false,
        }
    },

    created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });
        this.newsInfo = {
            articleType: 4,
            authorizationType: 1,
            content: "",
            title: "",
            departmentId: null,
            departmentIds: null,
            filePostDTOS: [],
            multiChoiceType: 0,
            optionResponseDTOS: [],
            organizationBranchId: this.$route.query.branch_id,
        };
        let postId = this.$route.query.postId;
        if (postId) {
            this.findById();
        }
        this.getClassDeparment();
    },
    computed: {
        branchModel: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value == this.newsInfo.organizationBranchId)),
                    value: this.newsInfo.organizationBranchId
                }
            },
            set(obj) {
                this.newsInfo.organizationBranchId = obj.value
                this.listDepartment()
            }
        },
        articleTypeModel: {
            get() {
                return {
                    label: this.getLabelString(this.articleTypeOptions.find(x => x.value == this.newsInfo.articleType)),
                    value: this.newsInfo.articleType
                }
            },
            set(obj) {
                this.newsInfo.articleType = obj.value;
                if (obj && obj.value == 2) {
                    this.isShowOption = true
                } else {
                    this.isShowOption = false
                }
            }
        },
        authorizationTypeModel: {
            get() {
                return {
                    label: this.getLabelString(this.authorizationTypeOptions.find(x => x.value == this.newsInfo.authorizationType)),
                    value: this.newsInfo.authorizationType
                }
            },
            set(obj) {
                this.newsInfo.authorizationType = obj.value;
                if (obj && obj.value == 1) {
                    this.isShowSelected = true
                } else {
                    this.isShowSelected = false
                }
            }
        },
        classTypeModelUpdate: {
            get() {
                return {
                    label: this.getLabelString(this.classOptions.find(x => x.value == this.newsInfo.departmentResponseDTO.id)),
                    value: this.newsInfo.departmentResponseDTO.id
                }
            },
            set(obj) {
                this.newsInfo.departmentId = obj.value;
            }
        },
        validateForm() {
            return !this.errors.any()
        },
    },

    methods: {

        getLabelString(object) {
            return (object && object.label) || this.$t('menuOrganization.null');
        },
        changeSelectClass() {
            this.newsInfo.departmentIds = [];
            this.classTypeModel.forEach(x => {
                this.newsInfo.departmentIds.push(x.value);
            })
            this.$validator.validate('selectClass');
        },

        getClassDeparment() {
            this.$vs.loading();
            this.$crm.get('/employee/get-teacher-departments')
                .then((response) => {
                    if (response.data && response.data.length > 0) {
                        this.classOptions = response.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName,
                            }
                        })
                    }
                    this.classOptions.unshift({ value: null, label: "Chưa xác định" })
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
        },
        findById() {
            this.$vs.loading();
            this.$crm.get('/post-news-feed/find-by-id?postId=' + this.$route.query.postId)
                .then((response) => {
                    let resFilePostDTOS = response

                    if (response.data) {
                        this.isUpdate = true;
                        this.newsInfo = response.data;
                        this.articleTypeModel = this.articleTypeOptions[response.data.articleType]
                        this.articleOptions = [];
                        response.data.optionResponseDTOS.forEach(x => {
                            this.articleOptions.push({ name: x.name });
                        });
                        this.filePostDTOS = resFilePostDTOS.data.filePosts;
                    }
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
        },
        listDepartment() {
            let searchInfo = {
                organizationBranchId: this.newsInfo.organizationBranchId
            }
            this.$crm.post('/department/find-by-condition', searchInfo).then((response) => {
                this.departmentOptions = response.data.map(x => {
                    return {
                        value: x.id,
                        label: x.departmentName
                    }
                });
                this.departmentOptions.unshift({ value: null, label: 'Không xác định' });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        async saveChanges(evt) {
            evt.preventDefault();
            try {
                if (!this.validateForm) return;
                const result = await this.$validator.validateAll();
                if (!result) return;
                await this.handleClickUploadFile();
                this.newsInfo.filePostDTOS = this.filePostDTOS;
                let url = this.isUpdate ? `/post-news-feed/update?postId=` + this.$route.query.postId : `/post-news-feed/create`,
                    data = this.newsInfo
                data.optionAddDTOS = this.articleOptions
                if (data.multiChoiceType) {
                    data.multiChoiceType = 1
                } else {
                    data.multiChoiceType = 0
                }
                this.$vs.loading();
                this.$crm.post(url, data).then(() => {
                    this.$vs.loading.close();
                    this.leaveList();
                    this.$vs.notify({
                        color: 'success',
                        text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} thành công`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } catch (ex) {
                console.log(ex);
            }
        },

        handleClickUploadFile() {
            return new Promise((resolve) => {
                let formData = new FormData(), config = {};
                let isUploadFile = 0;
                for (let i = 0; i < this.filePostDTOS.length; i++) {
                    let file = this.filePostDTOS[i];
                    if (!file.id) {
                        isUploadFile++;
                        formData.append('files', this.filePostDTOS[i]);
                    }
                }
                if (isUploadFile > 0) {
                    config = {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                    };
                    this.$vs.loading();
                    this.$crm.post(`/post-news-feed/file/upload?departmentIds=${this.newsInfo.departmentIds}`, formData, config).then((res) => {
                        res.data.forEach(file => {
                            this.filePostDTOS = this.filePostDTOS.filter(f => f.name != file.name);
                        });
                        this.filePostDTOS.push(...res.data);
                        resolve(true);
                    }).catch((err) => {
                        this.$vs.loading.close();
                        return this.$vs.notify({
                            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        });
                    });
                } else {
                    resolve(true);
                }
            });
        },

        uploadFieldChange(event) {
            this.filePostDTOS.push(...event.target.files);
            this.filePostDTOS = [...new Map(this.filePostDTOS.map(item =>
                [item['name'], item])).values()];
        },


        confirmDeleteFiles(file) {
            this.filePostDTOS = this.filePostDTOS.filter(x => x.name != file.name);
        },

        addNewRecord(index) {
            this.articleOptions.splice(index, 0, {})
        },
        confirmDeleteRecord(index) {
            this.selectedOptionsId = index;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.articleOptions.splice(this.selectedOptionsId, 1)
        },

        leaveList() {
            this.$router.push(`/user/manage-classroom-manager${this.newsInfo.organizationBranchId ? `?branch_id=${this.newsInfo.organizationBranchId}` : ''}`).catch(() => {
            })
        }
    },
}
</script>

<style scoped>
.custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
}

.custom-file-input::before {
    content: 'Chọn file';
    display: inline-block;
    background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
    border: 1px solid rgb(5, 152, 98);
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
}

.custom-file-input:hover::before {
    border-color: rgb(5, 152, 98);
}

.custom-file-input:active::before {
    background: -webkit-linear-gradient(top, rgb(5, 152, 98), rgb(5, 152, 98));
}

.btn-choose {
    width: 48% !important;
    text-align: center;
    background-color: white;
    justify-content: center;
    border-radius: 5px;
    border: 2px solid #ccc;
}

.btn-choose:hover {
    color: #059862;
    background-color: white;
    border-color: #059862;
}

#Upload {
    margin-top: 70px;
}

.input-content {
    height: 200px !important;
}
</style>
